var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66675 2C8.66675 0.895431 9.56218 0 10.6667 0C11.7713 0 12.6667 0.895431 12.6667 2C12.6667 2.06684 12.6635 2.13292 12.6571 2.19808C16.5799 2.99032 19.6707 6.07851 20.4667 10C20.5979 10.6462 20.6667 11.3151 20.6667 12H0.666748C0.666748 11.3151 0.735609 10.6462 0.866784 10C1.6628 6.07851 4.75357 2.99032 8.67643 2.19808C8.67003 2.13292 8.66675 2.06684 8.66675 2ZM2.91878 10C3.80687 6.54955 6.93907 4 10.6667 4V10H2.91878Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 15H3.25253L3.95964 15.7071C4.14718 15.8946 4.40153 16 4.66675 16H16.6667C16.932 16 17.1863 15.8946 17.3739 15.7071L18.081 15H20.6667V13H0.666748V15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfboard);
export default __webpack_public_path__ + "static/media/halfboard.b846c7b7a731a222b934b484ba277976.svg";
export { ForwardRef as ReactComponent };